<template>
  <div v-show="visible">
    <div class="header">
      <div :class="getWatchallLogoClass" />
    </div>
    <div class="body login">
      <el-form class="login-view" :model="loginData" :rules="loginFormRules" ref="loginForm" :show-message="false" :status-icon="true">
        <div class="login-id">
          <el-form-item prop="id">
            <el-input ref="idField" size="small" placeholder="ID" prefix-icon="fas fa-user" v-model="loginData.id" required clearable @keyup.enter.native="handleLogin"> </el-input>
          </el-form-item>
        </div>
        <div class="login-pw">
          <el-form-item prop="pw">
            <el-input size="small" type="password" placeholder="PASSWORD" prefix-icon="fas fa-lock-alt" v-model="loginData.pw" required clearable @keyup.enter.native="handleLogin"> </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="message-view">
        <el-row v-show="invalidMsg !== null" type="flex" justify="center" class="error">
          <i class="fas fa-exclamation-circle" style="margin-right:4px;"></i><span>{{ invalidMsg }}</span>
        </el-row>
      </div>
      <div class="tool-view">
        <span class="text-tool find-id"> <el-checkbox style="padding-right: 3px; position:relative; top:-3px" v-model="checkedSaveId"></el-checkbox> 아이디 저장</span>
        <span class="text-tool find-pw" @click="showPaasswordView">비밀번호 찾기 </span>
        <el-button @click="handleLogin"> LOGIN </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WLoginView',
  props: {
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      /**
       * 로그인 입력 정보 객체
       * id: 사용자 아이디
       * pw: 사용자 패스워드
       * @type {Object}
       */
      loginData: {
        id: null,
        pw: null,
      },
      /**
       * 로그인 폼 유효성 검사 조건
       * @type {Object}
       */
      loginFormRules: {
        id: [
          {
            required: true,
            trigger: 'change',
          },
        ],
        pw: [
          {
            required: true,
            trigger: 'change',
          },
        ],
      },
      /**
       * 로그인 실패 시 표현할 메시지
       * @type {String}
       */
      invalidMsg: null,
      loading: false,
      checkedSaveId: false,
    };
  },
  computed: {
    customerId() {
      return this.$store.state.common.customerId;
    },
    getWatchallLogoClass() {
      const customerId = this.customerId;
      if (customerId === 'SKCC') {
        return 'watchall-logo-skcc';
      } else if (customerId === 'SKT') {
        return 'watchall-logo-skt';
      }
      return 'watchall-logo';
    },
  },
  watch: {
    /**
     * 활성화된 뷰가 변경될 경우 각 뷰의 초기화 작업을 해준다.
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    visible(to) {
      if (to) {
        this.$refs.loginForm.resetFields();
        this.$refs.idField.focus();
        this.invalidMsg = null;
      }
    },
  },
  mounted() {
    const id = Cookies.get('cookieId');
    if (!isEmpty(id)) {
      this.loginData.id = id;
      this.checkedSaveId = true;
      this.loading = false;
    }
  },
  methods: {
    /**
     * 로그인을 시도한다.
     * @author Ju
     * @return {[type]} [description]
     */
    handleLogin() {
      this.invalidLogin = false;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch('login', {
              id: this.loginData.id,
              pw: this.loginData.pw,
            })
            .then((response) => {
              // 로그인 성공
              this.loading = false;
              if (!isEmpty(response.data)) {
                this.invalidMsg = null;

                // 쿠키 설정
                // $.cookie("checkAlarm", true, {path : "/"}); , $.cookie("checkAlarmNoti", true, {path : "/"}); 확인 필요,
                // 기존 v11과 다르게 로그인 성공 시 쿠키 저장
                if (this.checkedSaveId) {
                  const expires = new Date();
                  expires.setDate(expires.getDate() + 30);
                  Cookies.set('cookieId', this.loginData.id, {
                    expires,
                    path: '/',
                  });
                } else {
                  // 쿠키 삭제
                  Cookies.remove('cookieId', {
                    path: '',
                  });
                }

                this.$emit('login', response.data);
              } else if (!isEmpty(response.message)) {
                // 로그인 실패
                this.invalidMsg = response.message;
              } else {
                this.invalidMsg = '아이디나 비밀번호가 일치하지 않습니다.';
              }
            })
            .catch(() => {
              // 로그인 실패
              this.$emit('action-end');
              this.invalidMsg = '아이디나 비밀번호가 일치하지 않습니다.';
            });
        } else {
          this.invalidMsg = '아이디와 비밀번호를 입력해주십시오.';
        }
      });
    },
    showPaasswordView() {
      this.$emit('show-password-view');
    },
  },
};
</script>

<style lang="scss" scoped>
/* .body-wrapper {
  width: 100%;
  height: calc(100% - 140px);
  padding: 5px 0;
}

.el-loading-mask {
  bottom: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/views/login/components/LoginView.vue